import appStore from 'store';
import api from './api';
import { PAGINATION } from './constants';

const store = {
  namespaced: true,
  state: {
    tradePairList: [],
    pagination: PAGINATION,
    totalCount: 0,
    coinList: [],
    tradeArea: [],
    updateDialog: false
  },
  getters: {
    tradePairList: state => state.tradePairList,
    coinList: state =>
      state.coinList.map(coin => {
        return {
          label: coin,
          value: coin
        };
      }),
    tradeArea: state =>
      state.tradeArea.map(area => {
        return {
          label: area,
          value: area
        };
      })
  },
  mutations: {
    setTradePairList(state, payload) {
      state.tradePairList = payload.list.slice();
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setCoinList(state, payload) {
      state.coinList = payload;
    },
    setTradeArea(state, payload) {
      state.tradeArea = payload;
    },
    setUpdaterDialog(state, payload) {
      state.updateDialog = payload;
    }
  },
  actions: {
    async asyncDelHistoryData({commit},symbol){
      const res=await api.delHistory(symbol)
      return res
    },
  async  repairKline({commit},{ symbol, repairStartTime, repairEndTime,param }){

      const res=await api.repairKline({ symbol, repairStartTime, repairEndTime,param })
      return res
    },
    listAllCoin({ commit }) {
      api.getAllCoin().then(({ data }) => {
        commit('setCoinList', data);
      });
    },
    list({ commit }, { pair, area, page, size }) {
      api.getTradePairList({ pair, area, page, size }).then(({ data }) => {
        commit('setPagination', { page, size });
        commit('setTradePairList', data);
      });
    },
    // eslint-disable-next-line
    updateTradeStatus({ commit }, data) {
      return new Promise(resolve => {
        api.updateTradeStatus(data).then(res => {
          resolve(res);
        });
      });
    },
    // eslint-disable-next-line
    create({ commit }, tradePair) {
      return new Promise(resolve => {
        api.createTradePair(tradePair).then(res => {
          resolve(res);
        });
      });
    },
    // eslint-disable-next-line
    remove({ commit }, pair) {
      return new Promise(resolve => {
        api.removeTradePair(pair).then(res => {
          resolve(res);
        });
      });
    },
    // eslint-disable-next-line
    updateDefaultPrecision({ commit }, data) {
      return api.updateDefaultPrecision(data);
    },
    updateAmountPrecision({ commit }, data) {
      return api.updateAmountPrecision(data);
    },
    // eslint-disable-next-line
    transaction({ commit }, data) {
      return api.transaction(data);
    },
    getTradeArea({ commit }) {
      return api.getTradeArea().then(({ data }) => {
        commit('setTradeArea', data);
      });
    },
    updateSort(context, data) {
      return api.updateSort(data);
    },
    updateTradePair(context, data) {
      return api.updateTradePair(data);
    }
  }
};

appStore.registerModule('klineRepair', store);
